export default __webpack_public_path__ + "static/Yeppy-c13e73e389d31652194b56863cd94242.webp";